export default {
  SettingOrderSourceStrategySourcing: {
    title: '拖动排序，越靠前优先级越高',
    freightCost: '运费成本低',
    distance: '收发距离近',
    warehouseNum: '发货仓库少'
  }
};
